import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type Sort } from '@angular/material/sort';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import type { NormalizedDeviceData } from '@devices';
import type { BreadcrumbsMap } from '@devices/models/breadcrumbs';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeviceServiceV2 {
  private http = inject(HttpClient);

  deleteDevice(device: NormalizedDeviceData) {
    return this.http.delete(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${device.id}`,
    );
  }

  filters<T>(params?: { space?: string; }) {
    return this.http.get<{ data: T; }>(
      `devices/v2/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/filters`,
      {
        params: {
          ...params?.space && { space: params.space },
        },
      },
    );
  }

  list(params: { filters?: object; limit?: number; offset?: number; query?: string; sort?: Sort; }) {
    return this.http.get<{ count: number; data: NormalizedDeviceData[]; }>(
      `devices/v2/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices`,
      {
        params: {
          ...(params.filters && { filters: JSON.stringify(params.filters) }),
          ...(params.limit && { limit: params.limit }),
          ...(params.offset && { offset: params.offset }),
          ...(params.query && { query: params.query }),
          ...(params.sort && { sort: `${params.sort.active},${params.sort.direction}` }),
        },
      },
    );
  }

  cloneDevice(
    deviceId: string,
    body: { cloneNewFields: { locationId: string; name: string; serialNumber: string; spaceId: string; }[]; numberOfClones: number; }) {
    return this.http.post(
      `devices/v2/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${deviceId}/clone`,
      body,
    );
  }

  breadcrumbsMap(deviceId: string) {
    return this.http.get<{ data: BreadcrumbsMap }>(
      `devices/v2/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${deviceId}/breadcrumbs`,
    ).pipe(map(response => response.data));
  }
}
